import { type CustomCellRendererProps } from '@mint-lib/ag-grid/react';
import type { FC } from 'react';

import { OverflowMenuVertical } from '@mint-lib/icons';
import { Button } from '@mint-lib/tw-components';

import type { ApprovalTableItemData } from '../../../types/approversTable.js';

type Props = CustomCellRendererProps<ApprovalTableItemData>;

const ActionCell: FC<Props> = (props) => {
  const handleOpenContextMenu = () => {
    props.api.showContextMenu({
      ...props,
      source: 'ui',
      rowNode: props.node,
    });
  };

  return (
    <Button
      className="flex h-full w-full cursor-pointer items-center justify-center"
      icon
      variant="plain"
      size="large"
      color="primary"
      aria-label="open context menu"
      data-dd-action-name="Show context menu"
      onClick={handleOpenContextMenu}
    >
      <OverflowMenuVertical />
    </Button>
  );
};

export default ActionCell;
